<agr-page-toolbar
  [pageTitle]="pageTitle()"
  [isEmpty]="emptyCustomers$ | async"
  emptyTitle="{{ 'app.no_results_title' | translate }}"
  emptyDescription="{{ 'app.no_results_description' | translate }}"
  [emptyImage]="isAgrifirm ? 'assets/images/delivery.jpg' : ''"
>
  <ng-container actions>
    <app-search-field
      [value]="searchTextValue$ | async"
      [placeholderText]="'app.customer.search.placeholder' | translate"
      [isLoading$]="isLoading$"
      (searchValueChanged)="searchValueChanged($event)"
    ></app-search-field>
    <agr-primary-action
      actionIcon="add"
      [actionText]="'add' | translate"
      (action)="add()"
      data-test="customer__add"
    ></agr-primary-action>
  </ng-container>

  <agr-table-v2 [dataSource]="customersDataSource" [withSelection]="false">
    <ng-container *agrTableFiltersWrapper></ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>{{ 'app.customer.detail.name' | translate }}</th>
      <td mat-cell *matCellDef="let customer" data-test="customer-overview-item__name">
        <div class="overview-table__primary">{{ customer.name }}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="address">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'app.customer.detail.title_address' | translate }}
      </th>
      <td mat-cell *matCellDef="let customer" data-test="customer-overview-item__address">
        <div>{{ getAddress(customer) }}</div>
        <div class="text--gray">
          {{ getCity(customer) }}
          @if (customer.country) {
            <span>{{ 'app.countries.' + customer.country | translate }}</span>
          }
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="overview-table__row"
      data-test="customer-overview__item"
      tabindex="0"
      (click)="openCustomer(row)"
      (keydown.enter)="openCustomer(row)"
    ></tr>
    <tr *matNoDataRow>
      <td class="text--center" [attr.colspan]="displayedColumns.length">
        <agr-notification-empty
          [isEmpty]="true"
          emptyTitle="{{ 'app.no_results_title' | translate }}"
          emptyDescription="{{ 'app.no_results_description' | translate }}"
          [emptyImage]="isAgrifirm ? 'assets/images/delivery.jpg' : ''"
        ></agr-notification-empty>
      </td>
    </tr>
  </agr-table-v2>
</agr-page-toolbar>
